/**
 * Возвращает сгруппированную по id мероприятия карту
 * настроек, по всем трекам
 * @param {T[]} settings
 * @returns {Record<string, T[]>}
 */
export const combineEventsSettings = (settings) => {
  if (!settings || !settings.length) {
    return [];
  }
  return settings.reduce((acc, setting) => {
    if (settings) {
      const eventId = setting.event_id;
      if (!acc[eventId]) {
        acc[eventId] = [];
      }
      acc[eventId].push(setting);
    }
    return acc;
  }, []);
};
